const handleCreatives = ((jQuery) => {

  const initCreativesFormSteps = function () {
    var $form = jQuery('#new_creative_form');
    if ($form.length === 0) {
      return;
    }

    jQuery('#creative_click_target').val(''); // prevent browser caching an invalid url value

    _initCreativesFormStep1();
    _initCreativesFormStep2();
    _initCreativeFormStep3();

    var isInit = false;
    $form.steps({
      onInit: function () {
        var stepsValidator = $form.validate();
        stepsValidator.settings.ignore = [];
      },
      onChange: function (currentIndex, newIndex, stepDirection) {

        if (!isInit) {
          isInit = true;

          return;
        }

        var percent = (parseInt(currentIndex) / 2) * 100;
        jQuery('.progress-bar').css({width: percent + '%'});

        if (currentIndex === 2 && newIndex === 2 && stepDirection === 'none') {
          _handleCreativeFormStep3();
        }

        if (currentIndex === newIndex && stepDirection === 'none') {
          jQuery('*[data-step="step' + (newIndex + 1) + '"')
            .find('.is-valid').each(function () {
            jQuery(this).removeClass('is-valid');
          });
          return;
        }

        if ($form.valid()) {
          return true;
        } else if ([0, 1, 2].includes(currentIndex) && stepDirection === 'forward') {
          //console.dir($form.data("validator").errorList);
          toastr.error($form.data("validator").errorList[0].message);
        } else if (stepDirection === 'backward') {
          $form.data("validator").errorList.forEach(function (el) {
            jQuery(el.element).val('');
          });
          return true;
        }
      },
      onFinish: function () {
        $form.submit();
      }
    });
  };

  const _initCreativesFormStep1 = function () {

    jQuery('#creative_brand').on('change', function () {

      let idBrand = jQuery('#creative_brand').val()

      if ($.isNumeric(idBrand)) {
        jQuery('#buttonImportCreative').removeClass('d-none');
        jQuery('.creative-modal').removeClass('d-none');
        jQuery('#inputModalBrandId').val(idBrand);

      } else if(!jQuery('#creative_brand').hasClass('d-none')) {
        jQuery('#buttonImportCreative').addClass('d-none');
        jQuery('.creative-modal').addClass('d-none');
      }
    });

    jQuery('#form-import-creative').one('submit', event => {
      event.preventDefault();
      jQuery('#loading').removeClass('d-none');
      jQuery(event.currentTarget).submit();
    });
  }

  const _initCreativesFormStep2 = function () {

        const rmpFormats = [
            'megastar_fnac', 'megastar_darty', 'impulse_fnac', 'impulse_darty', 'impulse_product_fnac',
            'impulse_product_darty', 'stoprayon_fnac', 'stoprayon_darty', 'stoprayonproduct_fnac', 'stoprayonproduct_darty'
        ];

        const $inventory_format = jQuery("input[name='creative_inventory_format']:checked");
    if ($inventory_format) {
      jQuery('#row-' + $inventory_format.attr('id')).removeClass('d-none');
    }
    jQuery('input[name="creative_inventory_format"]').on('change', function () {
            const format = jQuery(this).attr('id');
      jQuery('.choice-hebergement').addClass('d-none');
            jQuery('#row-' + format).removeClass('d-none');
      jQuery('.indication-hebergement').removeClass('d-none');
      jQuery("input[name='creative_type']").prop('checked', false);
            if(rmpFormats.includes(format)) {
                _handleRmpTemplateStep3(format)
            }
    });
  };

    const _handleRmpTemplateStep3 = function(format) {
        let brandId = jQuery('#creative_brand').val();
        jQuery.ajax({
            type: 'GET',
            url: '/activation/creatives/rmp/templates?format=' + format + '&brandId=' + brandId,
            headers: {'X-CSRF-TOKEN': document.getElementsByName('_token')[0].value},
            success: function (data) {
                data = JSON.parse(data)
                jQuery('#step_3_rmp').html(data.html);
                jQuery('#' + data.name).prop('checked', true);
                _initColorPickers();
                $('[data-toggle="tooltip"]').tooltip();
                $('.isRequiredIfAjaxLoaded').addClass('requiredIfPanelActive');
                _handleImagesUploadPreview();
            },
            error: function (e) {
                console.error(e);
            }
        });
    };

    const _handleImagesUploadPreview = function () {
        jQuery('.creative-upload-img').on('change', function () {
            let $self = jQuery(this);
            let $previewImg = $self.parents('.upload-media').next().find('.preview-img');
            $previewImg.removeClass('d-none')
            let creativeUploadImg = new Image();
            let reader = new FileReader();
            let output = $previewImg[0];
            let dimensionsField = jQuery('#creative_dimension');
            $self.removeClass('invalid-dimension');
            reader.readAsDataURL(this.files[0]);
            reader.onload = function () {
                creativeUploadImg.src = reader.result;
                output.src = reader.result;
            };
            if (dimensionsField.length && dimensionsField.is(':visible')) {
                creativeUploadImg.onload = function () {
                    jQuery(output).css({
                        width: creativeUploadImg.width,
                        height: creativeUploadImg.height,
                        'margin-bottom': '1.5rem'
                    });
                    var optionVal = creativeUploadImg.width + 'x' + creativeUploadImg.height;
                    var selectOption = dimensionsField.find('option[value="' + optionVal + '"]');
                    if (selectOption.length && selectOption.css('display') !== 'none') {
                        selectOption.prop('selected', true);
                        $self.removeClass('invalid-dimension').valid();

                    } else {
                        $self.addClass('invalid-dimension').valid();
                        dimensionsField.prop('selectedIndex', 0);
                    }
                };
            }
        });
    };

  const _initCreativeFormStep3 = function () {

    jQuery('.add-more-pixel').click(function () {
      var format = jQuery(this).attr('data-format');
      var html = jQuery('.creative-thirdparty-pixels-' + format).html();
      jQuery('.thirdparty-pixels').after(html);
    });

    jQuery('body').on('click', '.remove', function () {
      jQuery(this).parents('.control-group').remove();
    });

    jQuery('.upload-file').on('change', function () {
      var $self = jQuery(this);
      if ($self[0] && $self[0].files) {
        id = jQuery(this).attr('id');
        var data = new FormData();
        data.append('file', $self[0].files[0]);
        data.append('_token', $self.attr("data-token"));
        jQuery.ajax({
          type: 'POST',
          url: $self.attr('data-action'),
          data: data,
          cache: false,
          contentType: false,
          processData: false,
          success: function (data) {
            if (id === 'creative_logo') {
              jQuery('#id_logo').val(data['id']);
              jQuery('#url_logo').val(data['cdn_secure_url']);

            } else {
              jQuery('#id_banniere').val(data['id']);
              jQuery('#url_banniere').val(data['cdn_secure_url']);
            }
          },
          error: function (data) {
            console.error(data);
          }
        });
      }
    });

    jQuery('#btn-preview').on('click', function (e) {

      e.preventDefault();

      jQuery('.input-native').addClass('requiredIfPanelActive');

      if (
        (jQuery('#creative_banniere').val() !== '' || jQuery('#url_banniere').val() !== '') &&
        jQuery('#creative_native_title, #creative_native_description').val() !== '' &&
        jQuery('#creative_native_sponsored_by, #creative_native_call_to_action').val() !== ''
      ) {
        var $form = jQuery(this).parents('form');
        var $formData = $form.serialize().replace('_method=PATCH&', '');
        jQuery.ajax({
          type: 'POST',
          url: jQuery(this).attr('data-action'),
          token: jQuery(this).attr('data-token'),
          data: $formData,
          success: function (data) {
            jQuery('#preview').html(data);
          },
          error: function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 422) {
              toastr.error('Veuillez completer tous les champs');
            } else {
              console.error(errorThrown);
            }
          },
        });
      }
    });

        _handleImagesUploadPreview();

    jQuery('#creative-media-Video').on('change', function () {
      jQuery('#video').removeClass('d-none');
      let file = this.files[0];
      let urlPreview = URL.createObjectURL(file);
      var video = document.getElementById('video');
      var source = document.getElementById('preview-video');
      source.setAttribute('src', urlPreview);
      video.load();
    });

    jQuery('#creative_third_party_url').on('keyup', function () {
      var format = jQuery('#creative_format').val();
      var hebergement = jQuery('#creative_hebergement').val();
      var fieldValue = jQuery(this).val();
      var isUrl = fieldValue.startsWith('http');

      if (format === 'Video' && hebergement === 'ThirdParty') {
        jQuery('#video').removeClass('d-none');
        var video = document.getElementById('video');
        var source = document.getElementById('preview-video');
        jQuery.ajax({
          type: 'POST',
          url: jQuery(this).attr('data-action'),
          data: {
            'third_tag_video': fieldValue,
            '_token': jQuery(this).attr('data-token')
          },
          success: function (data) {
            if (data) {
              source.setAttribute('src', data);
              video.load();
            }
          },
          error: function (data) {
            console.error(data);
          }
        });
      } else if (isUrl) {
        // third party image url preview
        var $preview_img = jQuery('#preview-img');
        $preview_img.removeClass('d-none');
        $preview_img.attr('src', jQuery(this).val())
      } else {
        // TODO third party tag preview
      }
    });
  };

    function step3_default() {
    var $creativeType = jQuery('input[name="creative_type"]');
    $creativeType.addClass('requiredIfPanelActive');
    $creativeType.each(function () {
      if (this.checked) {
        var type = jQuery(this).val().split('-');
        var inventory = type[0];
        var format = type[1];
        var hebergement = type[2];

        var nativeHiddenElements = jQuery('#btn-html-url, #creative_impressions_pixel');

        jQuery('#creative_inventory').val(inventory);
        jQuery('#creative_format').val(format);
        jQuery('#creative_hebergement').val(hebergement);

        jQuery(
          '.dimension, ' +
          '#video, ' +
          '#preview-img, ' +
          '.format-not-native, ' +
          '#Native, ' +
          '#third-party-url, ' +
          '#creative_impressions_pixel_native'
        ).addClass('d-none');

        jQuery('#creative_dimension, #creative_third_party_url, #creative-media-Display')
          .removeClass('requiredIfPanelActive');

        jQuery('#creative-media-' + format).removeClass('checkImageDimensions invalid-dimension');

        nativeHiddenElements.removeClass('d-none');

        if (format !== 'Native' && hebergement === 'Upload') {
          jQuery('#' + format + '-Upload').removeClass('d-none');
          jQuery('#creative-media-' + format).addClass('requiredIfPanelActive maxFileSize checkImageDimensions');
        } else if (format === 'Native') {

          nativeHiddenElements.addClass('d-none');
          jQuery('#Native, #creative_impressions_pixel_native').removeClass('d-none');
          jQuery('.input-native').addClass('requiredIfPanelActive');

        } else if (hebergement === 'ThirdParty') {
          jQuery('#impression_pixel').addClass('d-none');
          jQuery('#third-party-url').removeClass('d-none');
          jQuery('#creative_third_party_url').addClass('requiredIfPanelActive');
        }

        if (format === 'Display') {
          jQuery('.dimension').removeClass('d-none');
          jQuery('#creative_dimension').addClass('requiredIfPanelActive');
        }

        if (hebergement === 'Upload') {
          jQuery('#impression_pixel').removeClass('d-none');
        }

        if (format === 'Video' && hebergement === 'ThirdParty') {
          jQuery('.thirdparty-pixels')
            .hide()
            .nextAll('.control-group.input-group.m-2')
            .remove();
        } else {
          jQuery('.thirdparty-pixels').show();
        }

        if (jQuery('#creative-media-Display').val() !== '' && hebergement === 'Upload' && format === 'Display') {
          jQuery('#preview-img').removeClass('d-none');
        }

        if (jQuery('#creative-media-Video').val() !== '' && hebergement === 'Upload' && format === 'Video') {
          jQuery('#video').removeClass('d-none');
        }

        var OffsiteDisplayDimensions = jQuery('#creative_dimension').find('.offsite-additional-dimension');
        if (format === 'Display' && inventory === 'OFFSITE') {
          OffsiteDisplayDimensions.show();
        } else {
          OffsiteDisplayDimensions.hide();
        }
      }
    });
    }

    const _handleCreativeFormStep3 = function () {
        var $creativeType = jQuery('input[name="creative_type"]');
        $creativeType.addClass('requiredIfPanelActive');
        $creativeType.each(function () {
            if (this.checked) {
                const getConfigRmp = jQuery('#configRmp').val();
                const rmpDisplay = jQuery.parseJSON(getConfigRmp);
                const $step3Rmp = jQuery('#step_3_rmp');
                const $step3Default = jQuery('#step_3_default');
                const $newCreativeForm = jQuery('#new_creative_form');
                const type = jQuery(this).val().split('-');
                const format = type[1];

                $step3Default.hide();
                $step3Rmp.hide();

                if (jQuery.inArray(format, rmpDisplay) !== -1) {
                    $newCreativeForm.attr('action', '/activation/creatives/storeRmp');
                    $step3Default.hide();
                    $step3Rmp.show();
                    ['input', 'textarea', 'select'].forEach( function(element) {
                        $step3Default.find(element).each(function () {
                            jQuery(this).attr('disabled', 'disabled');
                        });
                    });
                } else {
                    $newCreativeForm.attr('action', '/activation/creatives');
                    $step3Default.show();
                    $step3Rmp.hide();
                    ['input', 'textarea', 'select'].forEach( function(element) {
                        $step3Default.find(element).each(function () {
                            jQuery(this).removeAttr('disabled');
                        });
                    });
                    step3_default();
                }
            }
        });
  };

  const handleCreativesPreview = function () {
    var modal = jQuery('#previewCreative');
    if (modal.length === 0) {
      return;
    }

    window.resizeIframe = function (iframe) {
      var height = iframe.contents().height();
      var width = iframe.contents().width();
      if (width > 1800) {
        width = 1200;
      }
      var modal = iframe.parents('.modal-dialog');
      modal.css({
        'max-height': height + 40,
        'max-width': width + 40
      });
      setTimeout(function () {
        iframe.animate({height: height, width: width}, 10, function () {
          modal.find('.card').addClass('d-none');
          modal.find('iframe').css('opacity', 1)
        });
      }, 500);
    }

    modal
      .on('show.bs.modal', function (e) {
        var creativeId = jQuery(e.relatedTarget).attr('data-id');
        var creativeFormat = jQuery(e.relatedTarget).attr('data-format');
        jQuery(this).find('.modal-body').html(
          '<iframe style="opacity:0; overflow:hidden;" ' +
          'class="border-0" id="resize_frame" onload="resizeIframe(jQuery(this))" ' +
          'src="/activation/creatives/preview/' + creativeId + '?t=' + new Date().getTime() + '"></iframe>'
        );
      })
      .on("hide.bs.modal", function () {
        jQuery(this).find('.modal-dialog').css({
          'max-height': 150,
          'max-width': 150
        });
        jQuery(this).find('.modal-body').html('');
        jQuery(this).find('.card').removeClass('d-none');
      });
  };

  const initCreativesEditForm = function () {
    var $form = jQuery('#form_edit_creative');
    if ($form.length === 0) {
      return;
    }

        _initColorPickers();

    $form.validate({
      ignore: ':hidden'
    });

    var type_hebergement = jQuery('#creative_hebergement').val();
    var format = jQuery('#creative_format').val();

    if (format === 'native') {
      jQuery('.input-native').addClass('required');
      var dataform = $form.serializeArray();
      dataform.shift();
      jQuery.ajax({
        type: 'POST',
        url: jQuery('#btn-preview').attr("data-action"),
        data: dataform,
        success: function (data) {
          jQuery('#preview').html(data);
        },
        error: function (data) {
          console.error(data);
        }
      });
    }

    if (type_hebergement === 'Upload') {
      jQuery('.upload-media').removeClass('d-none');
      jQuery('#third-party-url').addClass('d-none');

    } else {
      jQuery('.upload-media').addClass('d-none');
      jQuery('#third-party-url').removeClass('d-none');
    }

        jQuery('#flexCheckDefault').on('change', function () {
            if (this.checked) {
                jQuery('.cliquable-action').removeClass('d-none');
            } else {
                jQuery('#creative_click_target_rmp').val("");
                jQuery('.cliquable-action').addClass('d-none');

            }
        });

    _initCreativeFormStep3();

  }

    const _initColorPickers = () => {
        let colorpickers = document.querySelectorAll('.vcolorpicker');
        if (colorpickers.length === 0) {
            return;
        }
        colorpickers.forEach(colorpicker => {
            let picker = new Picker(colorpicker);
            // Set color picker default color (useful in edit forms)
            if (colorpicker.querySelector('input').value != '') {
              picker.setColor(colorpicker.querySelector('input').value);
              colorpicker.querySelector('.fa-square').style.color = colorpicker.querySelector('input').value;
            }
            picker.onChange = (color) => {
                colorpicker.querySelector('.fa-square').style.color = color.hex;
                colorpicker.querySelector('input').value = color.hex;
            };
        });
    };

  window.initCreativesIndex = function () {

    var creativesIndex = jQuery('#creatives-list');
    if (creativesIndex.length === 0) {
      return;
    }

    creativesIndex.removeClass('d-none');

    const handleCreativeSelection = function () {
      jQuery('#select-all').on('click', (e) => {
        e.preventDefault();
        jQuery("input[name^='creatives_id']:not(:checked)").trigger('click');
      });

      jQuery('#unselect-all').on('click', (e) => {
        e.preventDefault();
        jQuery("input[name^='creatives_id']:checked").trigger('click');
      });
    }

    jQuery('.creatives_checked').click(function () {
      var creatives_checked = jQuery("input[name='creatives_id[]']:checked");
      var count = creatives_checked.length;
      if (count === 1) {
        jQuery('#actions').removeClass('d-none');
        jQuery('#text-count-selection').text('1 Sélectionnée');
      } else if (count > 1) {
        jQuery('#actions').removeClass('d-none');
        jQuery('#text-count-selection').text(count + ' Sélectionnées');
      } else {
        jQuery('#actions').addClass('d-none');
      }
    });

    jQuery('#submit-actions').click(function () {
      jQuery('#form-creatives_actions').submit();
    })

    jQuery('.btn-actions').click(function () {
      var action = $(this).attr('data-actions');
      jQuery('.modal-title').addClass('d-none');
      jQuery('#input-type-actions').val(action);
      jQuery('#' + action + '-message').removeClass('d-none');
      var creatives_checked = jQuery("input[name='creatives_id[]']:checked");
      var table_modal = jQuery('#table-modal');
      table_modal.empty();
      creatives_checked.each(function () {
        table_modal.append('<tr ><td>' + $(this).next('label').text() + '</td></tr>');
      });
    });

    if (jQuery('#bulk-selection').length === 0) {
      jQuery('#buttons').append(`
            <div class="mb-2" id="bulk-selection">
                <a href="#" id="select-all">Tout selectionner </a> |
                <a href="#" id="unselect-all">Tout déselectionner</a>
            </div>`
      );
    }

    handleCreativeSelection();
  };

  jQuery(function () {
    initCreativesFormSteps();
    handleCreativesPreview();
    initCreativesEditForm();
  });
})(jQuery);
